import { render } from "./AddKontraktorPage.vue?vue&type=template&id=7527bb45&scoped=true"
import script from "./AddKontraktorPage.vue?vue&type=script&lang=js"
export * from "./AddKontraktorPage.vue?vue&type=script&lang=js"

import "./AddKontraktorPage.vue?vue&type=style&index=0&id=7527bb45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7527bb45"]])

export default __exports__